"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RoomsCountSelector = void 0;
var React = _interopRequireWildcard(require("react"));
var _ramda = require("ramda");
var _uiKit = require("@cian/ui-kit");
var _Dropdown = require("../../../packages/Dropdown");
var _DropdownFilterButton = require("../../../packages/DropdownFilterButton");
var _utils = require("../../utils");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const RoomsCountSelector = props => {
  const {
    value,
    onValueChange,
    className,
    errorMessage,
    values,
    isLastFilter,
    placeholder,
    placement
  } = props;
  const selectedLabel = value ? (0, _ramda.pathOr)(placeholder, [value, 'selectedLabel'], values) : placeholder;
  const valuesList = React.useMemo(() => (0, _utils.sortRoomsCount)(Object.values(values)), [values]);
  return /*#__PURE__*/React.createElement(_Dropdown.Dropdown, {
    placement: placement,
    testId: "roomsCount_filter_dropdown",
    master: _ref => {
      let {
        handleToggle,
        isOpen
      } = _ref;
      return /*#__PURE__*/React.createElement(_DropdownFilterButton.DropdownFilterButton, {
        label: selectedLabel,
        handleToggle: handleToggle,
        isLastFilter: isLastFilter,
        isEmpty: !value,
        isActive: isOpen,
        testId: "roomsCount_filter"
      });
    },
    render: _ref2 => {
      let {
        handleClose
      } = _ref2;
      return /*#__PURE__*/React.createElement(_uiKit.UiKitRoot, {
        deviceType: "phone",
        useStaticDeviceType: true
      }, /*#__PURE__*/React.createElement(_uiKit.RadioButtonGroup, {
        value: value || undefined,
        options: valuesList,
        onChange: (_, value) => {
          onValueChange(value);
          handleClose();
        },
        spliced: false
      }));
    },
    classes: {
      root: className
    },
    errorMessage: errorMessage
  });
};
exports.RoomsCountSelector = RoomsCountSelector;